













































































import { Vue, Component } from "vue-property-decorator";

@Component
export default class Gateway extends Vue {
  goToMyPortal() {
    this.$router.push({ path: "/my" });
  }

  goToAdminPortal() {
    this.$router.push({ path: "/admin" });
  }
}
